import { Field } from "react-final-form";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";

interface DatetimePickerProps {
  name: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  format?: string;
  minDate?:
    | Date
    | string
    | ((params: {
        values: Record<string, any>;
        allValues: Record<string, any>;
      }) => Date | string);
  maxDate?:
    | Date
    | string
    | ((params: {
        values: Record<string, any>;
        allValues: Record<string, any>;
      }) => Date | string);
  minTime?:
    | Date
    | string
    | ((params: {
        values: Record<string, any>;
        allValues: Record<string, any>;
      }) => Date | string);
  maxTime?:
    | Date
    | string
    | ((params: {
        values: Record<string, any>;
        allValues: Record<string, any>;
      }) => Date | string);
  /** Формат значения, отправляемого в форму. Без указания — как раньше, "сырой" moment. */
  outputFormat?: "moment" | "date-string" | "iso" | string;
  [key: string]: any;
}

export function DateTimePicker(props: DatetimePickerProps) {
  const {
    format = "DD MMMM YYYY HH:mm",
    outputFormat,
    minDate: minDateProp,
    maxDate: maxDateProp,
    minTime: minTimeProp,
    maxTime: maxTimeProp,
    ...fieldProps
  } = props;

  return (
    <Field
      {...fieldProps}
      render={({
        input: { onChange, value },
        label,
        helperText,
        required,
        meta,
      }: any) => {
        // Получаем текущие значения формы для динамических ограничений
        const formState = meta.formState || {};
        const values = formState.values || {};
        const allValues = values;

        // Обрабатываем динамические ограничения
        const getResolvedValue = (prop: any) => {
          if (typeof prop === "function") {
            return prop({ values, allValues });
          }
          return prop;
        };

        const minDate = getResolvedValue(minDateProp);
        const maxDate = getResolvedValue(maxDateProp);
        const minTime = getResolvedValue(minTimeProp);
        const maxTime = getResolvedValue(maxTimeProp);

        return (
          <MuiDateTimePicker
            label={label}
            ampm={false}
            value={value ? moment(value) : null}
            onChange={(newValue: any) => {
              if (!outputFormat) {
                onChange(newValue);
                return;
              }

              let outputValue = null;
              if (newValue) {
                switch (outputFormat) {
                  case "date-string":
                    outputValue = moment(newValue).format("YYYY-MM-DD HH:mm");
                    break;
                  case "iso":
                    outputValue = moment(newValue).toISOString();
                    break;
                  case "moment":
                    outputValue = newValue;
                    break;
                  default:
                    outputValue = moment(newValue).format(outputFormat);
                }
              }

              onChange(outputValue);
            }}
            format={format}
            minDate={minDate ? moment(minDate) : undefined}
            maxDate={maxDate ? moment(maxDate) : undefined}
            minTime={minTime ? moment(minTime) : undefined}
            maxTime={maxTime ? moment(maxTime) : undefined}
            slots={{
              openPickerButton: (props: any) => {
                return (
                  <InputAdornment position="end">
                    {value && (
                      <IconButton
                        size="small"
                        onClick={() => onChange(null)}
                        aria-label="clear"
                        style={{ marginRight: "-4px" }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                    <IconButton
                      {...props}
                      size="small"
                      color="primary"
                      aria-label="open picker"
                    >
                      {props.children}
                    </IconButton>
                  </InputAdornment>
                );
              },
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                required,
                helperText,
              },
            }}
          />
        );
      }}
    />
  );
}
